// Core
import React from 'react';
import { useQuery } from 'react-query';
import { 
	Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon,
	Box, Button, Flex, Text, Grid, Divider, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import { StarsIcon } from 'components/Icons/Icons';

const FAQ = () => {
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const background = useColorModeValue('white', '#0E1633');

  const { data, isLoading } = useQuery({
    queryKey: ['faq'],
    queryFn: async () => {
        const response = await apiService.getFAQs();
        return response.data;
    },
    refetchOnWindowFocus: false
  });

  return (
  	<Box maxW="744px" m="37px auto 100px auto">
  		<Flex gap={{base: '8px', md: '27px'}} m="0px 0 60px 0" w="100%" alignItems="center" justifyContent="center">
        	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
        	{ isDark && <Box bg="#099BFF" 
        		className="animation-opacity"
        		filter="blur(40px)" w="130px" h="40px" left="50%" borderRadius="full"
        		transform="translate(-50%, 40px)" position="absolute" zIndex="-1" />}
        	<Text variant="header" fontSize={{base: '46px', md: '64px', lg: '72px'}}>FAQ</Text>
        	<StarsIcon fontSize={{base: '28px', md: '43px'}} />
        </Flex>

  		{ !isLoading && data && (
			<Accordion allowMultiple>
	            { data?.content?.map((item, index) => (
	              <AccordionItem key={index} 
	                style={{ 
	                  background, 
	                  boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.10), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
	                  borderRadius: '8px', 
	                  margin: '0 0 16px 0',
	                  padding: '5px 0px',
	                  border: 'unset'}}>
	                <h2>
	                  <AccordionButton 
	                    sx={{
	                      _hover: { boxShadow: 'unset', bg: 'transparent' }, 
	                      _focus: { boxShadow: 'unset', bg: 'transparent' } 
	                    }}
	                  >
	                    <Text flex="1" textAlign="left" p="0 24px 0 0" variant="title-md">{item.title}</Text>
	                    <Box 
	                      borderRadius='4px'
	                      p="0px"
	                      w="21px"
	                      h="21px"
	                      background={background} >
	                      <AccordionIcon color="#0E1633" mt="-3px" fontSize="16px" />
	                    </Box>
	                  </AccordionButton>
	                </h2>
	                <AccordionPanel pb={4}>
	                  <Text variant="text-sm" fontWeight="400">{item.descriptions}</Text>
	                </AccordionPanel>
	              </AccordionItem>
	            ))}
          </Accordion>
  		)}
  	</Box>
  );
};

export default FAQ;